import React, { Suspense } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Loader from './component/loader';
import BackTop from './component/back-top';
import ScrollToTop from './component/ScrollToTop/ScrollToTop';

// All Headers
const Header1 = React.lazy(() => import('./layouts/header/Header1'));
const Header2 = React.lazy(() => import('./layouts/header/header2'));
const Header3 = React.lazy(() => import('./layouts/header/header3'));

// // All Footers
// const FooterStyle01 = React.lazy(() =>
//   import('./layouts/footer/footer-style-01')
// );
// const FooterStyle02 = React.lazy(() =>
//   import('./layouts/footer/footer-style-02')
// );
// const FooterStyle03 = React.lazy(() =>
//   import('./layouts/footer/footer-style-03')
// );

const ComingSoon = React.lazy(() => import('./pages/coming-soon'));
const Error404 = React.lazy(() => import('./pages/error404/error404'));
const PrivacyPolicy = React.lazy(() => import('./pages/privacy-policy'));
const TermsConditions = React.lazy(() => import('./pages/terms-conditions'));


// All Elements
const ElementsActionBox = React.lazy(() => import('./elements/action-box'));
const ElementsAccordion = React.lazy(() => import('./elements/accordion'));
const ElementsButton = React.lazy(() => import('./elements/button'));
const ElementsBlog = React.lazy(() => import('./elements/blog'));
const ElementsClientLogo = React.lazy(() => import('./elements/client-logo'));
const ElementsServices = React.lazy(() => import('./elements/services'));
const ElementsServiceBox = React.lazy(() => import('./elements/service-box'));
const ElementsCategoryBox = React.lazy(() => import('./elements/category-box'));
const ElementsCaseStudy = React.lazy(() => import('./elements/case-study'));
const ElementsCountdown = React.lazy(() => import('./elements/countdown'));
const ElementsCounter = React.lazy(() => import('./elements/counter'));
const ElementsTestimonial = React.lazy(() => import('./elements/testimonial'));
const ElementsInfoBox = React.lazy(() => import('./elements/infobox'));
const ElementsFeatureStep = React.lazy(() => import('./elements/feature-step'));
const ElementsPricingTable = React.lazy(() =>
  import('./elements/pricing-table')
);
const ElementsTeam = React.lazy(() => import('./elements/team'));
const ElementsTabs = React.lazy(() => import('./elements/tabs'));
const ElementsImageGallery = React.lazy(() =>
  import('./elements/image-gallery')
);
const ResponsiveMenu = React.lazy(() => import('./elements/menu'));
const ElementsFeatureInfo = React.lazy(() => import('./elements/feature-info'));
const ElementsList = React.lazy(() => import('./elements/list'));
const ElementsVideo = React.lazy(() => import('./elements/video'));


// 작업페이지
const Header = React.lazy(() => import('./layouts/header/index'));
const FooterStyle = React.lazy(() =>
  import('./layouts/footer/index')
);
const Main = React.lazy(() => import('./pages/main/index'));
const LoginPage = React.lazy(() => import('./pages/login/index'));
const FindPage = React.lazy(() => import('./pages/find/index'));
const ResetPage = React.lazy(() => import('./pages/reset/index'));
const JoinPage = React.lazy(() => import('./pages/join/index'));
const UserJoinPage = React.lazy(() => import('./pages/join/user'));
const CompanyJoinPage = React.lazy(() => import('./pages/join/company'));
const WelcomePage = React.lazy(() => import('./pages/join/welcome'));
const MyPage = React.lazy(() => import('./pages/join/mypage'));
const IntroducePage = React.lazy(() => import('./pages/introduce/index'));
const NewsletterPage = React.lazy(() => import('./pages/newsletter/index'));
const DetailPage = React.lazy(() => import('./pages/newsletter/detail'));
const NewPage = React.lazy(() => import('./pages/newsletter/new'));
const NewGalleryPage = React.lazy(() => import('./pages/newsletter/newGallery'));
const ListPage = React.lazy(() => import('./pages/newsletter/list'));
const CertificationPage = React.lazy(() => import('./pages/certification/index'));
const CertificationCheckPage = React.lazy(() => import('./pages/certification/check'));
const CertificationApplyPage = React.lazy(() => import('./pages/certification/apply'));
const CertificationHistoryPage = React.lazy(() => import('./pages/certification/history'));
const CertificationStepPage = React.lazy(() => import('./pages/certification/step'));
const VirtualPage = React.lazy(() => import('./pages/virtual/index'));
const VirtualSportsPage = React.lazy(() => import('./pages/virtual/sports'));
const VirtualIntroducePage = React.lazy(() => import('./pages/virtual/introduce'));
const VirtualTechnologyPage = React.lazy(() => import('./pages/virtual/technology'));

const DetailNewPage = React.lazy(() => import('./pages/newsletter/detail-new'));
const LisPeriodicalPage = React.lazy(() => import('./pages/newsletter/periodical'));
const MagazinePage = React.lazy(() => import('./pages/magazine/list'));
const MagazineDetailPage = React.lazy(() => import('./pages/magazine/detail'));
const NewMagazinePage = React.lazy(() => import('./pages/magazine/newMagazine'));

const AboutPage = React.lazy(() => import('./pages/about/index'));
const AboutMessagePage = React.lazy(() => import('./pages/about/message'));
const AboutOrganizationPage = React.lazy(() => import('./pages/about/organization'));
const AboutAdvisoryPage = React.lazy(() => import('./pages/about/advisory'));
const AboutStorePage = React.lazy(() => import('./pages/about/store'));
const AboutLocationPage = React.lazy(() => import('./pages/about/location'));
const AboutMembershipPage = React.lazy(() => import('./pages/about/membership'));




function App() {
  const location = useLocation();
  // const hideFooter = location.pathname !== '/join';

  return (
    <Suspense fallback={<Loader />}>
      <div className="main-wrapper">
      <ScrollToTop />
        <Routes>     
          {/* 1. 기본 헤더가 포함된 페이지 그룹 */}
          <Route element={<Header />}>
            <Route path="/" element={<Main />} />
            <Route path="/home" element={<Main />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/find" element={<FindPage />} />
            <Route path="/reset-password" element={<ResetPage />} />

            
            <Route path="/join/user" element={<UserJoinPage />} />
            <Route path="/join/company" element={<CompanyJoinPage />} />
            <Route path="/welcome" element={<WelcomePage />} />
            <Route path="/mypage" element={<MyPage />} />


            <Route path="/notice" element={<IntroducePage />} />
            <Route path="/newsletter" element={<NewsletterPage />} />
            <Route path="/detail/:id" element={<DetailPage />} />
            <Route path="/detail-new" element={<DetailNewPage />} />
            <Route path="/periodical" element={<LisPeriodicalPage />} />
            
            <Route path="/new" element={<NewPage />} />
            <Route path="/write-gallery" element={<NewGalleryPage />} />
            
            {/* 행사대회스케치 */}
            <Route path="/events" element={<ListPage />} />

            {/* 메거진 */}
            <Route path="/magazine" element={<MagazinePage />} />
            <Route path="/magazine/:id" element={<MagazineDetailPage />} />
            <Route path="/write-magazine" element={<NewMagazinePage />} />

            {/* 자격인증 */}
            <Route path="/certification" element={<CertificationPage />} />
            <Route path="/certification/check" element={<CertificationCheckPage />} />
            <Route path="/certification/apply" element={<CertificationApplyPage />} />
            <Route path="/certification/history" element={<CertificationHistoryPage />} />
            <Route path="/certification-intro" element={<CertificationStepPage />} />
            
            {/* 버추얼이란 */}            
            <Route path="/virtual" element={<VirtualPage />} />
            <Route path="/sports" element={<VirtualSportsPage />} />
            <Route path="/introduce" element={<VirtualIntroducePage />} />
            <Route path="/technology" element={<VirtualTechnologyPage />} />
            
            {/* 협회소개 */}
            <Route path="/about" element={<AboutPage />} />
            <Route path="/greetings" element={<AboutMessagePage />} />
            <Route path="/organization" element={<AboutOrganizationPage />} />
            <Route path="/advisory" element={<AboutAdvisoryPage />} />
            <Route path="/store" element={<AboutStorePage />} />
            <Route path="/location" element={<AboutLocationPage />} />
            <Route path="/membership" element={<AboutMembershipPage />} />
                      
            
            
          </Route>

          {/* 2. 헤더가 아예 없어야 하는 페이지 (단독 라우트) */}
          <Route path="/join" element={<JoinPage />} />
          
          {/* 3. 다른 종류의 헤더(Header2)를 써야 하는 페이지 그룹 */}
          {/* <Route element={<Header2 />}>
             <Route path="/home-2" element={<Home2 />} />
          </Route> */}

            {/* Pages */}
            <Route path="/*" element={<Error404 />} />
            {/* <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-and-conditions" element={<TermsConditions />} /> */}

            {/* Elements */}
            {/* <Route
              path="/elements-action-box"
              element={<ElementsActionBox />}
            />
            <Route path="/elements-accordion" element={<ElementsAccordion />} />
            <Route path="/elements-button" element={<ElementsButton />} />
            <Route path="/elements-blog" element={<ElementsBlog />} />
            <Route
              path="/elements-client-logo"
              element={<ElementsClientLogo />}
            />
            <Route path="/elements-services" element={<ElementsServices />} />
            <Route
              path="/elements-service-box"
              element={<ElementsServiceBox />}
            />
            <Route
              path="/elements-category-box"
              element={<ElementsCategoryBox />}
            />
            <Route
              path="/elements-case-study"
              element={<ElementsCaseStudy />}
            />
            <Route path="/elements-counter" element={<ElementsCounter />} />
            <Route path="/elements-countdown" element={<ElementsCountdown />} />
            <Route
              path="/elements-testimonial"
              element={<ElementsTestimonial />}
            />
            <Route path="/elements-infobox" element={<ElementsInfoBox />} />
            <Route
              path="/elements-feature-step"
              element={<ElementsFeatureStep />}
            />
            <Route
              path="/elements-pricing-table"
              element={<ElementsPricingTable />}
            />
            <Route path="/elements-team" element={<ElementsTeam />} />
            <Route path="/elements-tab" element={<ElementsTabs />} />
            <Route
              path="/elements-image-gallery"
              element={<ElementsImageGallery />}
            />
            <Route path="/elements-list" element={<ElementsList />} />
            <Route path="/elements-menu" element={<ResponsiveMenu />} />
            <Route
              path="/elements-feature-info"
              element={<ElementsFeatureInfo />}
            />
            <Route path="/elements-video" element={<ElementsVideo />} /> */}
        </Routes>
{/* 
        {hideFooter && (
          <Routes>
            <Route path="/*" element={<FooterStyle />} />{' '}
          </Routes>
        )}
         */}
        <Routes>
          <Route path="/*" element={<FooterStyle />} />{' '}
        </Routes>

        {/* Back to Top */}
        <BackTop />

        
      </div>
    </Suspense>
  );
}

export default App;
